import { css } from "../../../styled-system/css";

export const styles = {
  root: (isZoom: boolean) =>
    css({
      position: "absolute",
      bottom: "0",
      width: "baseUnit.mobile5",
      height: isZoom ? "baseUnit.mobile12" : "baseUnit.mobile5",
      borderRadius: "baseUnit.mobile4",
      backgroundColor: "white",
      fontWeight: "bold",
      cursor: "pointer",
      transition: "all 0.3s ease",
    }),
  button: () =>
    css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "baseUnit.mobile1",
      width: "baseUnit.mobile5",
      height: "baseUnit.mobile5",
      borderRadius: "100%",
      backgroundColor: "white",
      position: "absolute",
      _hover: {
        "& path": {
          fill: "intenseSeaBlue",
        },
      },
      _focusVisible: {
        outlineWidth: "2px",
        outlineStyle: "solid",
        outlineColor: "intenseSeaBlue",
        "& path": {
          fill: "intenseSeaBlue",
        },
      },
      _disabled: {
        cursor: "default",
        "&:hover path": {
          fill: "lightGrey",
        },
      },
    }),
  buttonZoomIn: () =>
    css({
      bottom: "0",
      zIndex: "highlight",
    }),
  buttonZoomOut: () =>
    css({
      desktop: {
        right: "0",
      },
    }),
  buttonWrapper: () =>
    css({
      position: "relative",
      width: "baseUnit.mobile5",
      height: "baseUnit.mobile5",
    }),
  icon: (isActive: boolean) =>
    css({
      "& svg": {
        width: "baseUnit.mobile3",
        height: "baseUnit.mobile3",
        "& path, & polygon": {
          fill: isActive ? "blueRefreshed" : "lightGrey",
        },
      },
    }),
};
